<template>
  <div class="gp-has-header">
    <mdb-card class="mb-4 text-left animated fadeInDown">
      <mdb-card-header class="banner">
        <avatar :avatar="group.avatar" :name="group.name" :size="60"/>
        <div class="group-name">
          <router-link :to="group.homeUrl" class="group-overlay-name text-white" v-if="group.homeUrl">{{group.name}}  <mdb-icon v-if="!suppressHomeIcon" icon="home" class="pr-2"></mdb-icon>
          </router-link>
        </div>
        <h5>{{title}}</h5>
        <mdb-btn @click="navBilling"
                 color="warning"
                 icon="money-bill-wave"
                 rounded size="sm" v-if="group.balance>0">Balance Due
        </mdb-btn>
      </mdb-card-header>
    </mdb-card>
    <mdb-modal size="lg" v-if="group && group.hasRequiredQuestions && !hideQuestions && !suppressQuestions">
      <mdb-modal-header class="secondary-color" :close="false" >

      </mdb-modal-header>
      <mdb-modal-body>
        <answers :group="group" :show-all="false" @submit="submittedAnswers"></answers>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbRow,
} from 'mdbvue';
import avatar from '../common/Avatar'
import api from "../../services/groupsPlaceApi";
import answers from './Answers'

export default {
    name: 'BannerSmall',
    components: {
      mdbIcon,
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbRow,
      mdbCol,
      mdbBtn,
      mdbModal,
      mdbModalBody,
      avatar,
      answers
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: ""
      },
      showBannerEdit: {
        type: Boolean,
        default: false
      },
      suppressQuestions: {
        type: Boolean,
        default: false
      },
      suppressHomeIcon: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        hideQuestions: false
      }
    },
    mounted() {

    },
    methods: {
      navBilling() {
        this.$router.push("/group/" + this.group.vanityPath + "/billing")
      },
      submittedAnswers(data) {
        this.hideQuestions = true
        if (!answers) location.reload()
        this.$store.dispatch("setExecuting", true)
        api.post("/member/answers/" + this.group.vanityPath, {questions: data}).then(
          (details) => {
            location.reload()
          },
          (error) => {
            this.$notify.error({message: "Could not post answers -> " + error.response.data, timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },

    }
    /*mounted() {
     this.$store.dispatch("setCurrentGroup", this.group)
     }*/
  };
</script>

<style scoped>
  @media screen and (max-width: 749px ) {
    .banner a {
      font-size: 1.2em;
      padding-top: 15px;
    }
  }

  @media screen and (min-width: 750px ) {
    .banner a {
      font-size: 1.5em;
      padding-top: 15px;
    }

  }

</style>
